import React from "react";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import { testimonials } from "../Data";

const Testimonials = () => {

  // Container stagger
  const container = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.2,
      },
    },
  };

  // Clean fade (no movement)
  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  // Card animation (safe)
  const cardAnim = {
    hidden: { opacity: 0, scale: 0.98 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.4,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="testimonials-section">

      {/* DOTS (refined, slower) */}
      <motion.div
        className="testimonials-dots"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.5, 0.9, 0.5],
        }}
        transition={{
          duration: 3,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      />

      <div className="container">

        {/* TEXT */}
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h3 className="section-subheading" variants={fade}>
            Bond for Generations
          </motion.h3>

          <motion.h2 className="section-heading" variants={fade}>
            Trusted by professionals across projects
          </motion.h2>
        </motion.div>

        {/* SWIPER */}
        <Swiper
          modules={[Autoplay, Pagination]}
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false
          }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
          }}
        >
          {testimonials.map((item) => (
            <SwiperSlide key={item.id}>
              
              <motion.div
                className="testimonial-card"
                variants={cardAnim}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                whileHover={{ scale: 1.02 }} // subtle only
                transition={{ duration: 0.2 }}
              >

                {/* TOP */}
                <div className="testimonial-top">
                  <img src={item.image} alt={`${item.name} | VigoFlex`} />

                  <div className="testimonial-info">
                    <h4>{item.name}</h4>
                    <p>{item.role}</p>
                  </div>
                </div>

                {/* DESC */}
                <p className="testimonial-desc">
                  {item.desc}
                </p>

              </motion.div>

            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default Testimonials;